import NewsletterRealtimeController from '../../realtime-controller'

/**
 * StatsController
 * Handles fetching and updating release statistics via socket.io
 */
class StatsController {
  constructor() {
    this.listeners = new Map()
  }

  /**
   * Start polling for release statistics
   * @param {string} releaseId - Release ID
   * @param {Function} onUpdate - Callback when stats are received
   * @param {number} intervalSeconds - Polling interval in seconds (default: 5)
   */
  startPolling(releaseId, onUpdate, intervalSeconds = 5) {
    if (this.listeners.has(releaseId)) {
      return
    }

    const socket = NewsletterRealtimeController.socket
    if (!socket || !socket.connected) {
      return
    }

    let tickCounter = 0

    const pollInterval = setInterval(() => {
      tickCounter++

      if (tickCounter >= intervalSeconds) {
        tickCounter = 0
        this.fetchStats(releaseId, onUpdate)
      }
    }, 1000)

    this.listeners.set(releaseId, { pollInterval, onUpdate })

    // Fetch immediately
    this.fetchStats(releaseId, onUpdate)
  }

  /**
   * Fetch statistics for a release
   * @param {string} releaseId - Release ID
   * @param {Function} onUpdate - Callback when stats are received
   */
  fetchStats(releaseId, onUpdate) {
    const socket = NewsletterRealtimeController.socket
    if (!socket || !socket.connected) {
      return
    }

    socket.emit('newsletter:get_release_stats', { release_id: releaseId }, (response) => {
      if (response?.success) {
        // Unwrap the data if it's nested (realtime system wraps responses)
        const statsData = response.data || response
        onUpdate(statsData)
      }
    })
  }

  /**
   * Stop polling for release statistics
   * @param {string} releaseId - Release ID
   */
  stopPolling(releaseId) {
    const listener = this.listeners.get(releaseId)
    if (!listener) return

    clearInterval(listener.pollInterval)
    this.listeners.delete(releaseId)
  }

  /**
   * Stop all polling
   */
  stopAll() {
    this.listeners.forEach((listener, releaseId) => {
      clearInterval(listener.pollInterval)
    })
    this.listeners.clear()
  }
}

export default new StatsController()
